var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Input, ButtonPrimary, IconLoading, ContentBox, H4 } from '@by-miles/bymiles-styles';
import { DataLayer } from '@by-miles/data-layer';
import { PostcodeStyle } from './PostcodeStyle';
import { DynamicTitle } from '../DynamicTitle';
import { eventSection } from '../../utils/event';
export var Postcode = function (postcodeProps) {
    var updatePostcode = postcodeProps.updatePostcode, updateState = postcodeProps.updateState, postcode = postcodeProps.postcode, step = postcodeProps.step, postcodeValid = postcodeProps.postcodeValid, fetching = postcodeProps.fetching, isQQPage = postcodeProps.isQQPage;
    var _a = useState(postcode), postCode = _a[0], setPostCode = _a[1];
    useEffect(function () {
        DataLayer.customEvent({
            eventName: 'postcode',
            eventType: 'virtual page view',
            section: eventSection(isQQPage),
        });
    }, []);
    var handlePostCodeConfirmed = function () {
        if (postcodeValid) {
            updateState({ stateName: 'step', value: step + 1 });
            DataLayer.customEvent({
                eventName: 'submit postcode',
                eventType: 'button click',
                section: eventSection(isQQPage),
            });
        }
    };
    return (_jsxs(PostcodeStyle, __assign({ isQQPage: isQQPage }, { children: [_jsx("div", __assign({ className: "title-wrapper" }, { children: _jsx(DynamicTitle, { isQQPage: isQQPage, className: "enter-details-title", title: _jsx("span", { children: "Tell us a little about yourself." }) }) })), _jsx(ContentBox, __assign({ isQQPage: isQQPage, className: "content-box" }, { children: _jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "widget-box-title padding" }, { children: _jsx(H4, { children: "What\u2019s your postcode?" }) })), fetching ? (_jsxs("div", __assign({ className: "fetching-mode" }, { children: ["Looking up postcode...", _jsx(IconLoading, {})] }))) : (_jsxs(_Fragment, { children: [_jsx(Input, { className: "postcode-input", name: "postcode", placeHolder: "Postcode", keepLabel: false, value: postCode, onChange: function (value) {
                                        setPostCode(value);
                                        updatePostcode(value);
                                    }, errorNoMessage: (postcode && !postcodeValid) || false, valid: postcodeValid }), _jsx("div", __assign({ className: "button-wrapper" }, { children: _jsx(ButtonPrimary, { iconRight: "IconCaretRight", label: "continue", onClick: function () { return handlePostCodeConfirmed(); } }) }))] }))] }) }))] })));
};
